import React from "react";

const ClefSelector = props => {

  if (props.gameType === 'frets') {
    return (
      <table className="clef-selector" valign="top" border="0">
        <thead><tr><th>Clef</th></tr></thead>
        <tbody>
          <tr><td> </td></tr>
        </tbody>
      </table>
    )
  } else {
    return (
      <table className="clef-selector" valign="top" border="0">
        <thead><tr><th>Clef</th></tr></thead>
        <tbody>
          <tr><td> <input type="radio" value='treble' checked={props.clef === 'treble'} onChange={() => props.callbacks.clefSetter("treble")} /> Treble</td></tr>
          <tr><td> <input type="radio" value="bass"   checked={props.clef === 'bass'}   onChange={() => props.callbacks.clefSetter("bass")}   /> Bass  </td></tr>
          <tr><td> <input type="radio" value="any"    checked={props.clef === 'any'}    onChange={() => props.callbacks.clefSetter("any")}    /> Any   </td></tr>
        </tbody>
      </table>
    )
  };

};

export default ClefSelector;






